module.exports = __webpack_public_path__ + "img/hidden-hero.5eeb2ce5.png";